<template>
  <el-dialog :title="$t('couponManage.giveCoupon')" :visible.sync="dialogVisible" width="500px"
    @close="handleClose">
    <el-form ref="form" :model="giveCouponInfo" label-width="100px">
      <el-form-item :label="$t('couponManage.selectCoupon')"
        :rules="[{ required: true, message: $t('couponManage.selectCouponRequired'), trigger: 'change' }]">
        <el-select v-model="giveCouponInfo.couponId" :placeholder="$t('couponManage.selectCouponRequired')"
          style="width:100%" @change="_changeCoupon">
          <el-option disabled :value="''" :label="$t('couponManage.selectCouponRequired')" />
          <el-option v-for="item in couponList" :key="item.couponId"
            :label="item.couponName" :value="item.couponId" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('couponManage.phoneNumber')"
        :rules="[{ required: true, message: $t('couponManage.phoneNumberRequired'), trigger: 'blur' }]">
        <el-input v-model="giveCouponInfo.tel"
          :placeholder="$t('couponManage.phoneNumberPlaceholder')" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="giveCouponMethod">
        {{ $t('couponManage.give') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { giveCoupon, listShopCoupon } from '@/api/coupon/couponApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'GiveCouponFromList',
  data() {
    return {
      dialogVisible: false,
      couponList: [],
      giveCouponInfo: {
        couponId: '',
        couponName: '',
        tel: ''
      }
    }
  },
  methods: {
    async open() {
      this.dialogVisible = true
      this._loadCoupons()
    },
    async _loadCoupons() {
      try {
        const res = await listShopCoupon({
          shopId: getShopId(),
          page: 1,
          row: 100
        })
        this.couponList = res.data || []
      } catch (error) {
        console.error(error)
      }
    },
    _changeCoupon() {
      const coupon = this.couponList.find(item => item.couponId === this.giveCouponInfo.couponId)
      if (coupon) {
        this.giveCouponInfo.couponName = coupon.couponName
      }
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.giveCouponInfo = {
        couponId: '',
        couponName: '',
        tel: ''
      }
      this.couponList = []
    },
    async giveCouponMethod() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              await giveCoupon({
                couponId: this.giveCouponInfo.couponId,
                tel: this.giveCouponInfo.tel
              })
              this.$message.success(this.$t('couponManage.giveSuccess'))
              this.dialogVisible = false
              this.$emit('refresh')
            } catch (error) {
              this.$message.error(error || this.$t('couponManage.giveFailed'))
            }
          }
        })
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>

